<div class="card m-0">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="m-0 fw-bold">Wrong Resident?</h6>
      </div>
      <div class="col-auto">
        <button type="button" class="btn" (click)="modal.hide()">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <p>Please enter the family code again or contact the community for additional assistance.</p>
  </div>

  <div class="card-footer">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
